module.exports = __webpack_public_path__ + "img/logo.ec9b02f5.png";